import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M7.13177 12.263C8.27038 12.2629 9.3762 11.8817 10.2731 11.1802L13.093 14L14 13.093L11.1801 10.2733C11.882 9.37636 12.2634 8.27034 12.2635 7.13149C12.2635 4.30212 9.9613 2 7.13177 2C4.30224 2 2 4.30212 2 7.13149C2 9.96087 4.30224 12.263 7.13177 12.263ZM7.13177 3.28287C9.2544 3.28287 10.9806 5.00898 10.9806 7.13149C10.9806 9.25401 9.2544 10.9801 7.13177 10.9801C5.00914 10.9801 3.28294 9.25401 3.28294 7.13149C3.28294 5.00898 5.00914 3.28287 7.13177 3.28287Z"
                fill="black"
            />
        </svg>
    );
};

export default React.memo(Search);
